import React from 'react';

export const FounderPortrait = () => (
  <figure className="w-full max-w-lg mx-auto min-w-0" data-testid="founder-portrait">
    <img
      src="/founder-image.jpg"
      alt="DMARKETINGCHAMP founder"
      width="4033"
      height="5041"
      loading="lazy"
      decoding="async"
      className="block w-full h-auto aspect-[4033/5041] object-contain rounded-lg"
      data-testid="founder-portrait-image"
    />
    <figcaption className="mt-5 border-l-2 border-[#BFB47E] pl-4" data-testid="founder-portrait-caption">
      <p className="text-sm font-bold text-[#0D234E]" data-testid="founder-portrait-brand">DMARKETINGCHAMP</p>
      <p className="mt-1 text-sm text-gray-600" data-testid="founder-portrait-tagline">Your Network, Your Future</p>
    </figcaption>
  </figure>
);